import {
  SET_DISPATCH_NOTIFICATION_ITEMS, UPDATE_DISPATCH_NOTIFICATION_ITEMS, 
  DELETE_DISPATCH_NOTIFICATION_PRODUCT_IN_LIST, CLEAR_DISPATCH_NOTIFICATIONS_ITEMS, SET_VENDOR_DATA,
  ADD_NEW_DISPATCH_ITEM
} from '../actions/actionTypes';
import cloneDeep from 'lodash/cloneDeep';


const initialState = {
  dn_list: null as any,
};

export function dnListReducer(state = initialState, action: any) {
  switch (action.type) {

    case SET_DISPATCH_NOTIFICATION_ITEMS:{
      console.log("action---data", action.data)
      return{
        ...state,
        dn_list:action.data
      }
    }

    case UPDATE_DISPATCH_NOTIFICATION_ITEMS:
      console.log("state.dn_list",state.dn_list)
      console.log("state.dn_list.dnItemsList", state.dn_list.dnItemsList)

      let itemList = state.dn_list.dnItemsList.slice();
      const newData = action.data;
      const objIndex = itemList.findIndex((i => i.itemIndex == newData.itemIndex));
      itemList[objIndex] = newData;
      return {
        ...state,
        dn_list : {...state.dn_list,dnItemsList:itemList}
      };
    
    case ADD_NEW_DISPATCH_ITEM:
      let existing_items = cloneDeep(state.dn_list.dnItemsList)
      
      let newObj = action.data;
      let updatedData =    [...existing_items, newObj]
      
      return{
        ...state,
        dn_list : {...state.dn_list,dnItemsList:updatedData}
      };

    case DELETE_DISPATCH_NOTIFICATION_PRODUCT_IN_LIST:
      let list_items = state.dn_list.dnItemsList.slice()
      
      const incomingObj = action.data;
      let resultant =  list_items.filter((i => i.itemIndex != incomingObj.itemIndex));
      
      return{
        ...state,
        dn_list : {...state.dn_list,dnItemsList:resultant}
      };

    case SET_VENDOR_DATA:{

      return{
        ...state,
        vendorData:action.data
      }
    }
    
    case CLEAR_DISPATCH_NOTIFICATIONS_ITEMS: return cloneDeep(initialState);
    default:
      return state;
  }
}
